import React from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';

function Education({ jobseeker,ref }) {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();
    return (
        <div ref={ref} id='education'  className={styles.educationContainer} style={{ width: '100%' }}>
            <h2 className={styles.heading}>{t('forms.education.heading')}</h2>
            {jobseeker?.education?.map((item, index) => {
                const isExpected = item.endDate > currentYear;
                return (
                    <div key={index}>
                        <h2 className={styles.title}>{item.institution}</h2>
                        <p className={`${styles.description} ${styles.educationDescription}`}>
                            {item.education_title}
                            {item.education_title && <br />}
                            {item.startDate}-{item.endDate} {isExpected && t('forms.education.expected')}
                        </p>
                    </div>
                );
            })}
        </div>
    );
}

export default Education;
